import validate from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  checkout: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/middleware/checkout.js")
}